import {createContext} from "react";

export interface INavigationPanelContext {
    NavPanelVisible: boolean;
    ToggleNavPanelVisible: () => void;
    HideNavPanel: () => void;
    ShowNavPanel: () => void;
    Navigate: (s: string, openInNewTab: boolean | undefined) => void;
}

export const NavigationPanelContext = createContext<INavigationPanelContext>(
    {} as any,
);
